import { useState } from "react";
import './menus.css';
import { useNavigate } from "react-router-dom";
import { Accordion, Nav } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

function T8_crm({setactivity, permission, usr_type, activeItem}) {
  const [isProductionOpen, setProductionOpen] = useState(true); // Predeterminadamente abierto
  const navigate = useNavigate();
  const activeStyles = { fontWeight: 600, backgroundColor: '#e7f1ff', color: '#0d6efd' };
  return (
    (
      <Accordion.Item eventKey="2">
        <Accordion.Header>
          <span role="img" aria-label="crm">🔔 </span> Sales Manager
        </Accordion.Header>
        <Accordion.Body className="p-0">
          <Nav className="flex-column">
            {parseInt(permission) >= 1 && (
              <Nav.Link active={activeItem === 'channels'} style={activeItem === 'channels' ? activeStyles : undefined} onClick={() => navigate('/channels')}>Resellers</Nav.Link>
            )}
          </Nav>
          <Nav className="flex-column">
            {parseInt(permission) >= 1 && (
              <Nav.Link active={activeItem === 'opportunities'} style={activeItem === 'opportunities' ? activeStyles : undefined} onClick={() => navigate('/opportunities')}>Opportunities</Nav.Link>
            )}
          </Nav>

          <Nav className="flex-column">
            {parseInt(usr_type) == 0 && (
              <Nav.Link active={activeItem === 'qrshorter'} style={activeItem === 'qrshorter' ? activeStyles : undefined} onClick={() => navigate('/qrshorter')}>QR Codes</Nav.Link>
            )}
          </Nav>
         
          <Nav className="flex-column">
            {permission === '5' && (
              <Nav.Link onClick={() => navigate('/opportunities')}>**** Estrategies Balance</Nav.Link>
            )}
          </Nav>
          <Nav className="flex-column">
            {permission === '5' && (
              <Nav.Link onClick={() => navigate('/opportunities')}>**** PyG Agents</Nav.Link>
            )}
          </Nav>
          
        </Accordion.Body>
      </Accordion.Item>
    )
  );
}

export default T8_crm;
